export default __webpack_public_path__ + "static/media/010-bracelet.d42999af.svg";